import { c as _c } from "react/compiler-runtime";
import { useQueryUserProfile } from 'src/profile/api';
import { useAuth } from 'shared/context/AuthContext';
import { NoClient as defaultClient, useCurrentClient } from 'shared/context/ClientContext';
import { useQueryMember } from 'src/workspace/api';
const useDashboardDataPreloader = () => {
  const $ = _c(5);
  const {
    currentUser,
    isSuccess: isAuthSuccess,
    isLoading: isLoadingAuth
  } = useAuth();
  const {
    isSuccess: isClientSuccess,
    isLoading: isLoadingClient,
    currentClient,
    error: clientError
  } = useCurrentClient();
  const {
    isSuccess: isMemberSuccess,
    isLoading: isLoadingMember,
    error: memberError
  } = useQueryMember(currentClient.id, currentUser?.id);
  const {
    isSuccess: isUserProfileSuccess,
    isLoading: isLoadingUserProfile,
    error: userProfileError
  } = useQueryUserProfile(currentUser?.id);
  const isLoading = isLoadingAuth || isLoadingClient || isLoadingMember || isLoadingUserProfile;
  const isValidClient = currentClient.id !== defaultClient.id && currentClient.name !== defaultClient.name && currentClient.featurePlan != null && currentClient.featurePlan.name !== defaultClient.featurePlan.name;
  const isSuccess = isClientSuccess && isMemberSuccess && isAuthSuccess && isUserProfileSuccess;
  const t0 = clientError != null || memberError != null || userProfileError != null;
  const t1 = !isLoading && (isValidClient || clientError != null || !isAuthSuccess);
  let t2;
  if ($[0] !== isLoading || $[1] !== isSuccess || $[2] !== t0 || $[3] !== t1) {
    t2 = {
      isLoading,
      isSuccess,
      isError: t0,
      isPreloaded: t1
    };
    $[0] = isLoading;
    $[1] = isSuccess;
    $[2] = t0;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export default useDashboardDataPreloader;